<ng-container>
  <span></span>
  <span></span>
  <span></span>
</ng-container>
